import { createRequest, getAccessToken } from './config';

const request = createRequest();

export const Voucher = {
  getVouchers: () =>
    request.get("/voucher", {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    })
};

export default Voucher;
